import React from "react";

// The same navigation tree serves both layouts. Only opening the compact menu
// is transient; it never writes the user's desktop sidebar preference.
export default function ResponsiveNavigation({ children, compact, open, onClose }) {
  const dialogRef = React.useRef(null);
  const closeRef = React.useRef(onClose);
  closeRef.current = onClose;

  React.useEffect(() => {
    if (!compact || !open) return undefined;
    const dialog = dialogRef.current;
    const opener = document.querySelector('[aria-controls="mobile-navigation"]');
    const previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = "hidden";
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    };
  }, [compact, open]);

  if (!compact) return children;
  if (!open) return null;
  return (
    <dialog
      ref={dialogRef}
      id="mobile-navigation"
      className="mobile-navigation-dialog"
      aria-label="Menu principal"
      onCancel={(event) => { event.preventDefault(); closeRef.current(); }}
      onClick={(event) => {
        if (event.target !== event.currentTarget) return;
        const rect = event.currentTarget.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeRef.current();
      }}
    >
      <button className="mobile-navigation-close" type="button" onClick={onClose} autoFocus>Fermer le menu</button>
      {children}
    </dialog>
  );
}
